import { Component } from 'react';
import { SnackBar } from 'components/uikit-adapter/index'
import Fetch from 'utils/fetch'
import Loading from 'components/center-loading'
import HeaderIcon from 'components/header-icon'
import { RoundingUnit } from 'components/icons/icn-index.icon'
import UnidadeArredondamentoList from './list'
import UnidadeArredondamentoForm from './form'
import ButtonNewItem from 'components/button-new-item'
import DeleteUnidadeArredondamento from 'components/delete-dialog'
import intl from 'react-intl-universal'

import StyledUnidadeArredondamento from './styledUnidadeArredondamento'
import { formatErrorMessage } from 'utils/handle-error';
import { profileAdminOrMasterData } from "services/permissions/getPermissions";

class UnidadeArredondamento extends Component {
  constructor() {
    super()
    this.state = {
      isFetching: false,
      unidadesArredondamentoList: [],
      total: 0,
      currentPage: 0,
      openForm: false,
      openEditMode: false,
      idSelected: 0,
      showFeedback: false,
      messageFeedBack: '',
      qtRegsPerPage: 50,
      openDelete: false
    }
  }

  componentDidMount() {
    this.buscarUnidadesArredondamento(this.state.currentPage)
  }

  buscarUnidadesArredondamento = (page) => {
    this.startFetching()
    Fetch.get(`/unidadeArredondamento/${this.state.qtRegsPerPage}/${page}`)
      .then((response) => this.proccessData(response.data))
      .then(this.stopFetching)
      .then(() => this.setState({ currentPage: page }))
      .catch((e) => this.proccessErro(e))
  }

  showFeedback = (message) => {
    this.setState({
      showFeedback: true,
      messageFeedBack: message
    })
  }

  closeFeedback = () => {
    this.setState({
      showFeedback: false
    })
  }

  openForm = () => {
    this.setState({
      openForm: true
    })
  }

  openNewForm = () => {
    this.setState({
      openEditMode: false
    }, () => this.openForm())
  }

  openEditForm = (row) => {
    if (profileAdminOrMasterData()) {
      const { unidadesArredondamentoList } = this.state;
      const selected = unidadesArredondamentoList[row]
      this.setState({
        openEditMode: true,
        idSelected: selected.Id
      }, () => this.openForm())
    }
  }

  closeForm = () => {
    this.setState({
      openForm: false
    })
  }

  startFetching = () => {
    this.setState({
      isFetching: true
    })
  }

  stopFetching = () => {
    this.setState({
      isFetching: false
    })
  }

  proccessErro = (exception) => {
    this.stopFetching()
    this.showFeedback(formatErrorMessage(exception))
  }

  refreshSearch = () => {
    this.closeForm()
    this.buscarUnidadesArredondamento(this.state.currentPage)
  }

  proccessData = (data) => {
    this.setState({
      unidadesArredondamentoList: data.Data,
      total: data.TotalRecordCount
    })
  }

  openDelete = (id) => {
    this.setState({
      openDelete: true,
      idSelected: id
    })
  }

  closeDelete = () => {
    this.setState({
      openDelete: false
    })
  }

  deleteUnidadeArredondamento = () => {
    const idUnidadeArredondamento = this.state.idSelected

    Fetch.delete(`/unidadeArredondamento/${idUnidadeArredondamento}`)
      .then(this.closeDelete)
      .then(() => this.refreshSearch())
      .then(() => this.showFeedback(intl.get('master-data.feedback.roundingUnitSuccessfullyDeleted')))
      .catch((e) => this.proccessErro(e))
  }

  render() {
    let {
      openForm,
      openEditMode,
      openDelete,
      idSelected,
      unidadesArredondamentoList,
      total,
      showFeedback,
      messageFeedBack,
      isFetching
    } = this.state
    return (
      <StyledUnidadeArredondamento>
        <Loading isLoading={isFetching} />

        <div className='unidade-header'>
          <HeaderIcon
            title={intl.get('master-data.configurations.roundedUnitys.header.title')}
            subtitle={intl.get('master-data.configurations.roundedUnitys.header.subtitle')}
            icon={<RoundingUnit width="45px" height="45px" color='var(--color-brand-500)' />}
          >
            {profileAdminOrMasterData() &&
              <div title={intl.get('master-data.configurations.roundedUnitys.actions.newRoundedUnity')}>
                <ButtonNewItem
                  className='general-button'
                  onClick={this.openNewForm}
                />
              </div>
            }
          </HeaderIcon>
        </div>

        <UnidadeArredondamentoList
          data={unidadesArredondamentoList}
          countData={total}
          refreshSearch={this.buscarUnidadesArredondamento}
          handleEdit={this.openEditForm}
          handleDelete={this.openDelete}
          qtRegsPerPage={this.state.qtRegsPerPage}
          profileAdminOrMasterData={profileAdminOrMasterData()}
        />

        {openForm &&
          <UnidadeArredondamentoForm
            idEdit={idSelected}
            open={openForm}
            editMode={openEditMode}
            handleClose={this.closeForm}
            handleRefresh={this.refreshSearch}
            handleFeedback={this.showFeedback}
            profileAdminOrMasterData={profileAdminOrMasterData()}
          />
        }

        <DeleteUnidadeArredondamento
          open={openDelete}
          title={intl.get('master-data.configurations.roundedUnitys.actions.deleteRoundedUnity')}
          handleClose={this.closeDelete}
          warningMessage={intl.get('master-data.general.materials.description')}
          handleConfirm={this.deleteUnidadeArredondamento}
        />

        <SnackBar
          message={messageFeedBack}
          open={showFeedback}
          autoHideDuration={3000}
          onRequestClose={this.closeFeedback}
        />
      </StyledUnidadeArredondamento>
    );
  }
}
export default UnidadeArredondamento;
